import styled from 'styled-components';

export const ItemWrapper = styled.div`
  display: flex;
  min-width: 200px;
  padding: 8px 12px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background: ${({ theme }) => theme.colors.black2};
  }
`;

export const TextWrapper = styled.span<{ $isCompleted: boolean }>`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;
  overflow: hidden;
  color: ${({ $isCompleted, theme }) => ($isCompleted ? theme.colors.black7 : theme.colors.black9)};
  text-overflow: ellipsis;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const DetailsWrapper = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black7};
  text-overflow: ellipsis;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
